import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";

const httpLink = new HttpLink({
  uri: import.meta.env.VITE_FRONT_END_GRAPHQL_READ_URL as string,
});

const authLink = new SetContextLink((prevContext) => {
  const token = import.meta.env.VITE_FRONT_END_TOKEN as string;

  const prevHeaders = (prevContext.headers ?? {}) as Record<string, string>;

  return {
    ...prevContext,
    headers: {
      ...prevHeaders,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});